module.exports = __webpack_public_path__ + "static/media/canada.f7c837c0.svg";